<template>
  <v-container fluid>
    <v-row>
      <div class='header'>
        <h2>О лаборатории</h2>
      </div>

      <div class='horizontal-rule' />

      <LabPreview class="mt-5"/>

      <div class='header'>
        <h2>Коллектив</h2>
      </div>

      <div class='horizontal-rule' />

      <v-expansion-panels
          :readonly="false"
          multiple
          class="mt-5 mb-5"
      >
      <PersonaComponent v-for="(persona, index) in personas" :key="persona.name" :persona="persona"/>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import LabPreview from "@/components/LabPageComponents/LabPreview";
import PersonaComponent from "@/components/LabPageComponents/PersonaComponent";
import {getPersonas} from "@/helpers/personaInfo";

export default {
  name: "LabPage",
  components: {LabPreview, PersonaComponent},
  data () {
    return {
      personas: [],
    }
  },

  created() {
    this.personas = getPersonas()
  }

}
</script>

<style scoped>

</style>